@if (src && name) {
  <div class="avatar-container">
    <img class="profile-picture" [ngSrc]="src" width="40" height="40" alt="{{'TOOLTIP.PROFILE' | translate}}">
    <div class="avatar-text">{{ name }}</div>
  </div>
}
